export const backendUrl = process.env.REACT_APP_BACKEND || '';

export function authHeaders(user) {
  return {
    'Content-Type': 'application/json',
    ...(user?.jwt ? { Authorization: `Bearer ${user.jwt}` } : {}),
  };
}

export async function requestJson(path, options = {}) {
  const response = await fetch(`${backendUrl}${path}`, {
    mode: 'cors',
    cache: 'no-cache',
    credentials: 'same-origin',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(options.headers || {}),
    },
  });

  if (!response.ok) {
    const error = new Error(`Request failed with status ${response.status}`);
    error.status = response.status;
    throw error;
  }

  return response.json();
}
